import { render } from "./AccountMarketingHub.vue?vue&type=template&id=11f8202e&scoped=true"
import script from "./AccountMarketingHub.vue?vue&type=script&lang=js"
export * from "./AccountMarketingHub.vue?vue&type=script&lang=js"

import "./AccountMarketingHub.vue?vue&type=style&index=0&id=11f8202e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11f8202e"]])

export default __exports__